import { observable } from "mobx"
import { getRequest } from "../../common/helpers/RequestHelper"
import { IStockSymbol, STOCK_BG_COLOR_CONIG } from "../../common/model/Model"
import { appStore } from "../../common/store/AppStore"
import { Moment } from "../../common/utils/Moment";
import Constants from './../../common/constants/Constants';
import HttpStatusCode from './../../common/constants/HttpErrorCode';
import _ from "lodash"
interface ICompanyOverview {
    marketCapital: number;
    firstPrice: number;
    priceChange52Week: string;
    averageVolume10Day?: any;
    percentPriceChange1Week: number;
    percentPriceChange1Month: number;
    percentPriceChange3Month: number;
    percentPriceChange6Month: number;
    percentPriceChange1Year: number;
    percentPriceChangeYTD: number;
    percentPriceChangeFTD?: any;
    outstandingShare: number;
    freeFloat: number;
    roomForeign?: any;
    pe: number;
    dilutionPE?: any;
    pb: number;
    eps: number;
    dilutionEPS?: any;
    bookValue?: any;
    lastInterest: number;
    roe: number;
    ratingBasicRate: number;
    pointCalcBasicPoint: number;
    pointCalcGrowthPoint: number
}
interface ICompanyStructure {
    ownership: {
        ownershipId: number;
        organCode: string;
        outstandingShare: number;
        publicDate: Date;
        foreignerVolumn: number;
        foreignerRoom: number;
        foreignerPercentage: number;
        stateVolumn: number;
        statePercentage: number;
        otherVolumn: number;
        otherPercentage: number;
        totalForeignRoom: number;
        maximumForeignPercentage: number;
        tradingDate: Date;
        status: number;
    },
    shareHolderMajor: {
        fullName: string
        fullNameEn: string
        percentage: number
        quantity: number
    },
    listShareHolder: {
        fullName: string
        fullNameEn: string
        percentage: number
        quantity: number
    }[]

}
interface ICompanyNormalInfo {
    organCode: string;
    ticker: string;
    comGroupCode: string;
    comTypeCode: string;
    organName: string;
    organShortName: string;
    enOrganName: string;
    enOrganShortName: string;
    taxCode: string;
    enterpriseCode: string;
    address: string;
    enAddress: string;
    telephone: string;
    fax: string;
    email: string;
    website: string;
    logo: string;
    outstandingShare: number;
    freeFloat: number;
    freeFloatRate: number;
    issueShare: number;
    charterCapital: number;
    firstPrice: number;
    firstVolumn: number;
    numberOfShareHolder: number;
    status: number;
}
interface IShareIssuse {
    shareIssueId: number;
    organCode: string;
    issueYear: number;
    planVolumn: number;
    issueVolumn: number;
    publicDate: any;
    issueDate: any;
    listingDate: any;
}
interface IDividend {
    cashDividendPayoutId: number;
    organCode: string;
    publicDate: Date;
    payoutDate: Date;
    dividendYear: number;
    valuePershare: number;
    exerciseRate: number;
    note: string;
    dividendStageName: string;
    dividendStageNameEn: string;
}
export enum InfoTab {
    Info = 1,
    Owner = 2,
    ChildCompany = 3,
    Affiliate = 4
}
interface IOwner {
    positionShortName: string;
    positionShortNameEn: string;
    positionName: string;
    positionNameEn: string;
    fullName: string;
    fullNameEn: string;
}
interface IChildContainer {
    organName: string;
    organNameEn: string;
    shortOrganName: string;
    shortOrganNameEn: string;
    holingPercent: number;
}
export interface IPriceHistory {
    hoseStockId: number;
    organCode?: any;
    ticker?: any;
    tradingDate: Date;
    matchPrice?: any;
    referencePrice?: any;
    priceChange: number;
    percentPriceChange: number;
    totalVolume: number;
    totalMatchVolumeEven: number;
    totalDealVolume: number;
    totalValue: number;
    totalMatchValueEven: number;
    totalDealValue: number;
    openPrice: number;
    closePrice: number;
    highestPrice: number;
    lowestPrice: number;
}
export interface ITradingStatistic {
    hoseStockId: number;
    organCode: string;
    ticker: string;
    tradingDate: Date;
    matchPrice: number;
    referencePrice: number;
    percentPriceChange: number;
    totalBuyTrade: number;
    totalBuyTradeVolume: number;
    totalSellTrade: number;
    totalSellTradeVolume: number;
    averageVolume1Buy: string;
    averageVolume1Sell: string;
    netVolume: number;
}
export interface IForeignTrading {
    hoseStockId: number;
    organCode: string;
    ticker: string;
    tradingDate: Date;
    foreignBuyValueTotal: number;
    foreignBuyVolumeTotal: number;
    foreignSellValueTotal: number;
    foreignSellVolumeTotal: number;
    netBuyVolume: number;
    netBuyValue: number;
}
export interface IShareHolder {
    dealId: number;
    organCode: string;
    traderCode: string;
    actionTypeCode: string;
    traderShortName: string;
    traderShortNameEn: string;
    traderName: string;
    traderNameEn: string;
    rolePersonName?: any;
    rolePersonNameEn?: any;
    shareBeforeTrade: number;
    shareRegister: number;
    shareAcquire: number;
    buyShareRegister?: any;
    sellShareRegister: number;
    buyShareAcquire?: any;
    sellShareAcquire: number;
    startDate: Date;
    endDate: Date;
    publicDate: Date;
    tradeStatusName: string;
    tradeStatusNameEn: string; s
}
export interface IMarketFund {
    treasuryStockId: number;
    organCode: string;
    actionTypeCode: string;
    actionTypeName: string;
    actionTypeNameEn: string;
    issueStatusName: string;
    issueStatusNameEn: string;
    publicDate: Date;
    shareBeforeTrade: number;
    shareRegisted: number;
    shareAcquire: number;
    priceAcquire: number;
    valueAcquire: number;
    shareAfterTrade: number;
    startDate: Date;
    endDate: Date;
}
interface IFileDownload {
    financialReportFileId: number;
    organCode: string;
    ticker: string;
    financialReportTypeCode: string;
    financialReportTypeName: string;
    financialReportTypeNameEn: string;
    yearReport: number;
    lengthReport: number;
    title: string;
    titleEn: string;
    sourceUrl: string;
    sourceUrlEn: string;
    reportFileType: string;
    note: string;
    publicDate: Date;
}
interface ICategory {
    displayOrder: number
    financialReportTypeCode: string
    financialReportTypeName: string
    financialReportTypeNameEn: string
}
interface INews {
    "newsId": number,
    "newsTitle": string,
    "newsImageUrl": string | null,
    "publicDate": string
}
interface ISameGroup {
    "stockSymbol": string,
    "pe": number,
    "eps": number,
    matchPrice: number,
    colorUpdate: string,
    percentChange?: number,
    priceChange?: number,
    volume: number,
    basicPrice: number,
    ceilingPrice: number,
    floorPrice: number
}
interface IShortInfo {
    stockSymbol: string;
    floorCode: string;
    companyName: string;
    companyNameEn: string;
    icbCode: string;
    enIcbName: string;
    icbName: string;
}
class StockDetailStore {
    @observable symbol: string = ""
    @observable stockSymbolInfo?: IStockSymbol
    @observable stockShortInfo?: IShortInfo
    @observable sameSymbols: string[] = []
    @observable companyOverview?: ICompanyOverview
    @observable companyStructure?: ICompanyStructure
    @observable tabActive = InfoTab.Info
    @observable normalInfo?: ICompanyNormalInfo
    @observable ownerInfo: IOwner[] = []
    @observable childContainer: IChildContainer[] = []
    @observable transactionTab = 1
    @observable page: number = 1
    @observable size: number = 20
    @observable filterBy: string = "day"
    @observable from: number = new Date().getTime() - 365 * 86400 * 1000
    @observable to: number = new Date().getTime()
    @observable priceHistory: IPriceHistory[] = []
    @observable tradingStatistic: ITradingStatistic[] = []
    @observable foreignTrading: IForeignTrading[] = []
    @observable shareHolder: IShareHolder[] = []
    @observable marketFund: IMarketFund[] = []
    @observable companyNewsTab: number = 1
    @observable news: INews[] = []
    @observable newsIndexPage: number = 1
    @observable newsSize: number = 10
    @observable newsTotalPages: number = 0
    @observable shareIssue: IShareIssuse[] = []
    @observable dividends: IDividend[] = []
    @observable categories: ICategory[] = []
    @observable category: string = ""
    @observable sameGroupSymbols: ISameGroup[] = []
    @observable totalPages: number = 0
    @observable fileDownloads: {
        year: number,
        data: IFileDownload[]
    }[] = []
    @observable transactionLoading: boolean = false
    @observable year: number = 0;

    regisSocket() {
        appStore.regisShortStockInfo()
    }

    async getStockInfo() {
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'GetCompanyIndustryByStockSymbol?ticker=' + this.symbol)
        if (result.status < HttpStatusCode.CODE_300) {
            this.stockShortInfo = result.body
        }
    }

    updateStockSymbol(data: IStockSymbol[]) {
        this.sameGroupSymbols.forEach((item) => {
            let newStock = data.find((index) => (index.stockSymbol === item.stockSymbol))
            if (newStock) {
                let t: IStockSymbol = _.cloneDeep(newStock);
                if (item.matchPrice && t.matchPrice && item.matchPrice < t.matchPrice) {
                    t.colorUpdate = STOCK_BG_COLOR_CONIG.UP
                }
                if (item.matchPrice && t.matchPrice && item.matchPrice > t.matchPrice) {
                    t.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
                }
                if (item.matchPrice !== t.matchPrice) {
                    item.basicPrice = t.basicPrice
                    item.ceilingPrice = t.ceilingPrice;
                    item.matchPrice = t.matchPrice
                    item.volume = t.matchQtty
                    item.floorPrice = t.floorPrice
                    item.priceChange=t.priceChange
                    item.percentChange=t.priceChangePercent
                    setTimeout(() => {
                        item.colorUpdate = ""
                    }, Constants.EFFECT_UPDATE_TIME)
                }

            }
        })
        let newStock = data.find((index) => (index.stockSymbol === this.symbol))
        if (newStock) {
            let t: IStockSymbol = _.cloneDeep(newStock);
            if (this.stockSymbolInfo && this.stockSymbolInfo.matchPrice && t.matchPrice && this.stockSymbolInfo.matchPrice < t.matchPrice) {
                t.colorUpdate = STOCK_BG_COLOR_CONIG.UP
            }
            if (this.stockSymbolInfo && this.stockSymbolInfo.matchPrice && t.matchPrice && this.stockSymbolInfo.matchPrice > t.matchPrice) {
                t.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
            }
            if (this.stockSymbolInfo) {
                if (this.stockSymbolInfo.matchPrice !== t.matchPrice || this.stockSymbolInfo.matchValue === t.matchValue) {
                    this.stockSymbolInfo = t
                    setTimeout(() => {
                        if (this.stockSymbolInfo)
                            this.stockSymbolInfo.colorUpdate = ""
                    }, Constants.EFFECT_UPDATE_TIME)
                    this.stockSymbolInfo = t
                }
            }
            else {
                this.stockSymbolInfo = t
                setTimeout(() => {
                    if (this.stockSymbolInfo)
                        this.stockSymbolInfo.colorUpdate = ""
                }, Constants.EFFECT_UPDATE_TIME)
                this.stockSymbolInfo = t
            }
        }
    }
    async getCompanyOverview() {
        const result = await getRequest(Constants.API_DASHBOARD_URL + "GetListCompanyOverView?stockSymbol=" + this.symbol)
        if (result.status < HttpStatusCode.CODE_300) {
            this.companyOverview = result.body
        }
    }
    async getCompanyStructure() {
        const result = await getRequest(Constants.API_DASHBOARD_URL + "GetShareHolderStructure?ticker=" + this.symbol)
        if (result.status < HttpStatusCode.CODE_300) {
            if (result.body.ownership !== null) {
                this.companyStructure = result.body;
                if (this.companyStructure && this.companyStructure.listShareHolder) {
                    this.companyStructure.listShareHolder = _.uniqBy(this.companyStructure?.listShareHolder ?? [], 'fullName');
                }                
            }

        }
    }
    async getCompanyInfo() {
        if (this.tabActive === InfoTab.Info) {
            const result = await getRequest(Constants.API_DASHBOARD_URL + "GetComanyInfo?ticker=" + this.symbol)
            if (result.status < HttpStatusCode.CODE_300) {
                this.normalInfo = result.body
            }
        }
        if (this.tabActive === InfoTab.Owner) {
            const result = await getRequest(Constants.API_DASHBOARD_URL + "GetIndividual?ticker=" + this.symbol)
            if (result.status < HttpStatusCode.CODE_300) {
                this.ownerInfo = result.body
                // this.ownerInfo.map(())
            }
        }
        if (this.tabActive === InfoTab.ChildCompany) {
            const result = await getRequest(Constants.API_DASHBOARD_URL + `GetSubsidiaryAndAffiliateCompanyInfo?ticker=${this.symbol}&typeCompany=1`)
            if (result.status < HttpStatusCode.CODE_300) {
                result.body.sort(function (a, b) {
                    return b.holingPercent - a.holingPercent;
                });
                this.childContainer = result.body
            }
        }
        if (this.tabActive === InfoTab.Affiliate) {
            const result = await getRequest(Constants.API_DASHBOARD_URL + `GetSubsidiaryAndAffiliateCompanyInfo?ticker=${this.symbol}&typeCompany=2`)
            if (result.status < HttpStatusCode.CODE_300) {
                this.childContainer =  result.body.sort(function (a, b) {
                    return b.holingPercent - a.holingPercent;
                });
                this.childContainer = result.body
            }
        }
    }
    handleChangeTabClick(tab: number) {
        this.tabActive = tab;
        this.getCompanyInfo()
    }
    async getTransactionStatistic() {
        let from = Moment.convert_datetime(stockDetailStore.from)
        let to = Moment.convert_datetime(stockDetailStore.to)
        this.totalPages = 0
        this.transactionLoading = true
        if (this.transactionTab === 1) {
            const api = `GetListPriceHistory?stockSymbol=${this.symbol}&pageSize=${this.size}&pageIndex=${this.page}&dateFrom=${from}&dateTo=${to}&filter=${this.filterBy}`
            const result = await getRequest(Constants.API_DASHBOARD_URL + api)
            if (result.status < HttpStatusCode.CODE_300) {
                if (result.body.data !== null) {
                    this.priceHistory = result.body.data
                }
                else {
                    this.priceHistory = []
                }
                this.totalPages = result.body.paging.totalPages
            }
        }
        if (this.transactionTab === 2) {
            const api = `GetListStatisticTrading?stockSymbol=${this.symbol}&pageSize=${this.size}&pageIndex=${this.page}&dateFrom=${from}&dateTo=${to}&filter=${this.filterBy}`
            const result = await getRequest(Constants.API_DASHBOARD_URL + api)
            if (result.status < HttpStatusCode.CODE_300) {
                if (result.body.data !== null) {
                    this.tradingStatistic = result.body.data
                }
                else {
                    this.tradingStatistic = []
                }
                this.totalPages = result.body.paging.totalPages
            }
        }
        if (this.transactionTab === 3) {
            const api = `GetListForeignTrading?stockSymbol=${this.symbol}&pageSize=${this.size}&pageIndex=${this.page}&dateFrom=${from}&dateTo=${to}`
            const result = await getRequest(Constants.API_DASHBOARD_URL + api)
            if (result.status < HttpStatusCode.CODE_300) {
                if (result.body.data !== null) {
                    this.foreignTrading = result.body.data
                }
                else {
                    this.foreignTrading = []
                }
                this.totalPages = result.body.paging.totalPages
            }
        }
        if (this.transactionTab === 4) {
            const api = `GetListMarketShareHolder?stockSymbol=${this.symbol}&pageSize=${this.size}&pageIndex=${this.page}&dateFrom=${from}&dateTo=${to}`
            const result = await getRequest(Constants.API_DASHBOARD_URL + api)
            if (result.status < HttpStatusCode.CODE_300) {
                if (result.body.data !== null) {
                    this.shareHolder = result.body.data
                }
                else {
                    this.shareHolder = []
                }
                this.totalPages = result.body.paging.totalPages
            }
        }
        if (this.transactionTab === 5) {
            const api = `GetListMarketFund?stockSymbol=${this.symbol}&pageSize=${this.size}&pageIndex=${this.page}&dateFrom=${from}&dateTo=${to}`
            const result = await getRequest(Constants.API_DASHBOARD_URL + api)
            if (result.status < HttpStatusCode.CODE_300) {
                if (result.body.data !== null) {
                    this.marketFund = result.body.data
                }
                else {
                    this.marketFund = []
                }
                this.totalPages = result.body.paging.totalPages
            }

        }
        this.transactionLoading = false
    }
    async getListFinancialReportCategory() {
        const result = await getRequest(Constants.API_DASHBOARD_URL + "GetListFinancialReportCategory")
        if (result.status < HttpStatusCode.CODE_300) {
            this.categories = result.body
        }
    }
    handleChangeTransactionTabClick(id: number) {
        this.transactionTab = id;
        this.page = 1;
        this.getTransactionStatistic()
    }
    handleChangeFilterBy(by: string) {
        this.filterBy = by;
        this.page = 1;
        this.getTransactionStatistic()
    }
    changeNewsPage(page) {
        if (page > this.newsIndexPage) {
            if (page <= this.newsTotalPages) {
                this.newsIndexPage = page;
                this.getCompanyNews()
            }
        }
        else {
            if (page > 0) {
                this.newsIndexPage = page;
                this.getCompanyNews()
            }

        }
    }
    async getCompanyNews() {
        if (this.companyNewsTab === 1) {
            const result = await getRequest(Constants.API_DASHBOARD_URL + `GetListCompanyNews?stockSymbol=${this.symbol}&pageSize=${this.newsSize}&pageIndex=${this.newsIndexPage}&year=${this.year}`)
            if (result.status < HttpStatusCode.CODE_300) {
                this.news = result.body.data
                this.newsTotalPages = result.body.paging.totalPages
            }
        }
        if (this.companyNewsTab === 2) {
            const result = await getRequest(Constants.API_DASHBOARD_URL + `GetListShareIssue?stockSymbol=${this.symbol}&pageSize=${this.newsSize}&pageIndex=1&year=${this.year}`)
            if (result.status < HttpStatusCode.CODE_300) {
                this.shareIssue = result.body.data
            }
        }
        if (this.companyNewsTab === 3) {
            const result = await getRequest(Constants.API_DASHBOARD_URL + `GetListCashDividendPayout?stockSymbol=${this.symbol}&pageSize=${this.newsSize}&pageIndex=1&year=${this.year}`)
            if (result.status < HttpStatusCode.CODE_300) {
                this.dividends = result.body.data
            }
        }
        if (this.companyNewsTab === 4) {

            const result = await getRequest(Constants.API_DASHBOARD_URL + `GetListFileDownload?stockSymbol=${this.symbol}&year=${this.year}&category=` + this.category)
            if (result.status < HttpStatusCode.CODE_300) {
                let m: {
                    year: number,
                    data: IFileDownload[]
                }[] = []
                result.body.data.forEach((item) => {
                    let exist = m.find((index) => index.year === item.yearReport)
                    if (!exist) {
                        let data = {
                            year: item.yearReport,
                            data: []
                        }
                        m.push(data)
                    }
                })
                result.body.data.forEach((item) => {
                    m.forEach((index) => {
                        if (item.yearReport === index.year) {
                            index.data.push((item))
                        }
                    })
                })
                this.fileDownloads = m
            }
            if (this.categories.length === 0) {
                this.getListFinancialReportCategory()
            }
        }
    }
    handleChangeTabCompanyNews(tab: number) {
        this.companyNewsTab = tab
        // if (tab === 4) {
        //     this.year = 0
        // }
        // else {
        //     this.year = new Date().getFullYear()
        // }
        this.year = 0
        this.getCompanyNews()
    }
    handleChangeFilterByYearCompanyNews(year: number) {
        this.year = year;
        this.getCompanyNews()
    }
    handleSelectCategory(cate) {
        this.category = cate;
        this.getCompanyNews()
    }
    async getListStockSameIndustry() {
        const result = await getRequest(Constants.API_DASHBOARD_URL + `GetListStockSameIndustry?stockSymbol=${this.symbol}&pageSize=7&pageIndex=1`)
        if (result.status < HttpStatusCode.CODE_300) {
            this.sameGroupSymbols = result.body.data
            this.sameGroupSymbols.forEach((item) => {
                this.sameSymbols.push(item.stockSymbol)
            })
        }
    }
    handleChangeDateFrom(date) {
        if (new Date(date).getTime() > this.to) {
            // let to = _.cloneDeep(this.to)
            // this.to = new Date(date).getTime()
            // this.from = to
            alert("Ngày bắt đầu phải trước ngày kết thúc!")
        }
        else {
            this.from = new Date(date).getTime()
            this.page = 1;
            this.getTransactionStatistic()
        }

    }
    handleChangeDateTo(date) {
        if (new Date(date).getTime() < this.from) {
            // let from = _.cloneDeep(this.from)
            // this.to = from
            // this.from = new Date(date).getTime()
            alert("Ngày kết thúc phải sau ngày bắt đầu!")
        }
        else {
            this.to = new Date(date).getTime()
            this.page = 1;
            this.getTransactionStatistic()
        }

    }
    handlePageChange(page) {
        if (page > this.page) {
            if (page <= this.totalPages) {
                this.page = page;
                this.getTransactionStatistic()
            }
        }
        else {
            if (page > 0) {
                this.page = page;
                this.getTransactionStatistic()
            }

        }

    }
    async getDataExcel() {
        let data = []
        if (this.transactionTab === 1) {

        }
        return data
    }
}
export const stockDetailStore = new StockDetailStore()